Vue.component('rms-objects', {
    props: ['user'],
    data: function(){
        return {
        }
    },
    methods: {
    },
});
